<template>
    <v-container class="app-page-container">
        <v-card v-if = "test_info">
            <v-card-title>
                {{test_info.test_name}}
            </v-card-title>
            <v-card-text>
                <Test1 v-if="test_info.id == 1"/>
                <Test2 v-if="test_info.id == 2"/>            
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import Test1 from '../../elements/psycho_tests/cog_number.vue'
import Test2 from '../../elements/psycho_tests/cog_number_sep.vue'

export default {
    data() {
        return {
            test_type: 0,
            test_info: null
        }
    },
    mounted() {
        this.initData()
    },
    components: {
        Test1, Test2
    },
    methods : {
        initData() {
            this.test_type = this.$route.params.id
            let _name = 'undefined'
            axios.get('/get-info-psycho-test/' + this.test_type, this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    /* eslint-disable no-console */
                    // console.log(res.data)
                    if (res.data.message == 'OK') {
                        this.test_info = res.data.info[0]
                        _name = this.test_info.test_name
                    } else {
                        this.$store.commit('setFeedback', res.data.message)    
                    }
                    const bc = [ 
                        { text: 'Cognitive tests', href: '/cognitive_tests/' },
                        { text: _name, href: '/cognitive_test/' + this.test_type },
                    ]
                    this.$store.commit('setBreadCrumbs',bc)                        
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
    }
}
</script>